export const optionalJobFields = ['salary', 'education', 'jobtype', 'experience', 'referencenumber', 'postalcode'];
